export enum RoutesEnum {
  StartPage = "/",
  DashboardPage = "/dashboard",
  UserLogin = "/login",
  CallBack = "/callback",
  GuestListPage = "/profile",
  GuestProfilePage = ":profileId",
  OffersPage = "/offers",

  Status403Page = "/403",

  UIKitPage = "/ui-kit",
  NotFound = "/:pathMatch(.*)*",
}
